import { WithTranslation } from 'react-i18next';

export interface SegmentRuleRowProps extends WithTranslation {
    rule: string;
    ruleObject: SegmentRuleRowState;
    position: string;
    classes: any;
    onChangeRuleFieldSelect: (rule: string) => void;
    onClickAddSubrule: () => void;
    onClickAddRule: () => void;
    onClickRemoveSubrule: () => void;
    index: string;
}

export interface RuleFieldOptionInterface {
    label: string;
    value: string;
    ruleConditionType: RuleConditionType;
    ruleValueType: RuleValueType;
    isNotFieldFound?: boolean;
    labelTranslated?: string;
}

export interface SegmentRuleRowState {
    ruleField: RuleFieldOptionInterface;
    ruleCondition: any;
    ruleValue: any;
}

export type RuleValueType =
    | 'String'
    | 'Number'
    | 'Boolean'
    | 'Datetime'
    | 'Listname'
    | 'ConsentTracking'
    | 'UnsubscribeReason'
    | 'Source'
    | 'Status'
    | 'Date';

export type ReturnEventHandler = (event: React.SyntheticEvent<HTMLElement>, pickedField?: any) => void;

export type RuleConditionType = 'text' | 'number' | 'datetime' | 'currency' | 'boolean' | 'bignumber' | 'date';

export enum RuleConditionTypeToConditionOptions {
    text = 'String',
    number = 'Number',
    datetime = 'Datetime',
    currency = 'Number',
    boolean = 'Boolean',
    bignumber = 'Number',
    date = 'Date',
}

export interface RuleFieldOptionsInterface {
    [key: string]: RuleFieldOptionInterface[];
}

export interface RuleValueOptionsInterface {
    Boolean: OptionInterface[];
    ConsentTracking: OptionInterface[];
    UnsubscribeReason: OptionInterface[];
    Source: OptionInterface[];
    Status: OptionInterface[];
    Listname?: OptionInterface[];
}

export interface OptionInterface {
    label: string;
    value: string;
    labelTranslated?: string;
}

export interface ConditionOptionsInterface {
    String: OptionInterface[];
    Number: OptionInterface[];
    Datetime: OptionInterface[];
    Boolean: OptionInterface[];
    Date: OptionInterface[];
}
